// Helpers shared by the Professional Development pages and the dashboard
// hero.
import {salaryAt, FUTURE_YEARS} from "@/components/package/scaleMath";

// "12", "12.5" — never "12.0"
export function formatHours(v) {
    const n = parseFloat(v) || 0;
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

export function pdRoute(view) {
    return view ? {name: 'pd', params: {view}} : {path: '/professional-development'};
}

// What moving from the current lane to `target` adds up to over the same
// five years the pitch charts show (year 1 through FUTURE_YEARS, one more
// year of service each year). Same math as PackagePitch's "what waiting
// costs" total.
export function fiveYearGain(position, target) {
    if (!position || !target || !target.lane) return 0;
    let total = 0;
    for (let y = 1; y <= FUTURE_YEARS; y++) {
        const move = salaryAt(target.lane, position.exp + y);
        const stay = salaryAt(position.current, position.exp + y);
        if (move === null || stay === null) continue;
        total += move - stay;
    }
    return Math.max(0, Math.round(total));
}

// Days until a renewal / expiry DATE string; null when absent
export function daysUntil(dateOnly) {
    if (!dateOnly) return null;
    const target = new Date(String(dateOnly).slice(0, 10) + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.round((target - today) / 86400000);
}
